<template>
    <div class="col-12 mb-primary">
        <h3 class="card-title d-inline-block mb-0">{{ $t('site_title') }}</h3>
        <!-- <div class="float-right">
            how do other people see your profile? <a href="companyprofile/view" class="btn btn-primary btn-sm">View As</a>
        </div> -->
        <app-overlay-loader v-if="preloader"/>
        <div class="card-body">
            <form ref="form" data-url="/crud" class="mb-0" :class="{'loading-opacity': preloader}">
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>{{ $t('site_code') }}</label>
                            <app-input type="text"
                                v-model="inputs.site_code"
                                :required="true"/>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>{{ $t('description') }}</label>
                            <app-input type="textarea"
                                v-model="inputs.description"
                                :required="true" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>{{ $t('starting_hours') }}</label>
                            <app-input type="time"
                                v-model="inputs.starting_hours"
                                :required="true" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>{{ $t('ending_hours') }}</label>
                            <app-input type="time"
                                v-model="inputs.ending_hours"
                                :required="true"/>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label>{{ $t('assignment_structure2') }}</label>
                            <p class="mb-0">File.pdf</p>
                            <p>file.docs</p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12">
                        <p class="font-weight-bold">Task List</p>
                        <table class="table">
                            <tr>
                                <th>S.No</th>
                                <th>Task List</th>
                                <th>Status</th>
                                <th>Assigned User</th>
                                <th>Action</th>
                            </tr>
                            <tr>
                                <td>1</td>
                                <td>Quality Management</td>
                                <td>Supervisor</td>
                                <td>User 1(Cosmo)</td>
                                <td><button class="btn btn-primary btn-sm">view</button></td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>Quality Management</td>
                                <td>Supervisor</td>
                                <td>User 1(Cosmo)</td>
                                <td><button class="btn btn-primary btn-sm">view</button></td>
                            </tr>
                        </table>
                    </div>
                </div>
            </form>
        </div>
    </div>

</template>

<script>
    import {FormMixin} from '../../../../../../../core/mixins/form/FormMixin.js';

    export default {
        name: "FormGrid",
        mixins: [FormMixin],
        data() {
            return {
                isAddEditModalActive: false,
                preloader: false,
                inputs: {},
            }
        },
        methods: {
            beforeSubmit(){
                this.preloader = true;
            },
            submit() {
                this.save(this.inputs);
            },

            afterSuccess(res) {
                this.$toastr.s(res.data.message);
            },
            afterFinalResponse() {
                this.preloader = false;
                this.inputs = {
                    gender: 'male',
                };
            },
            afterError(res) {
                this.$toastr.e(res.data.message);
            },
            clear() {
                this.inputs = {};
                this.fieldStatus = {
                    isSubmit: false
                }
            },
            openAddEditModal() {
            this.isAddEditModalActive = true;
        },

        /**
         * for close add edit modal
         */
        closeAddEditModal() {
            this.isAddEditModalActive = false;
        },
        }
    }
</script>